'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const moment=require('pulsar-utils/dist-es6/time/moment');
const Formatters=require('../../../../../../../dist-es6/client/formatters');

const LocalMidnight=moment('1970-01-01');let
DoNotDisturbScheduleItemDirective=function(_BaseControllerBacked){_inherits(DoNotDisturbScheduleItemDirective,_BaseControllerBacked);function DoNotDisturbScheduleItemDirective(){_classCallCheck(this,DoNotDisturbScheduleItemDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(DoNotDisturbScheduleItemDirective,[{key:'objectBindings',get:function()
{
return[
'schedule',
'togglePauseCommand',
'deleteCommand'];

}},{key:'templateUrl',get:function()

{
return'/templates/features/notificationSettings/components/doNotDisturbNotificationSettings/directives/doNotDisturbScheduleItemTemplate';
}},{key:'controller',get:function()

{
return DoNotDisturbScheduleItemController;
}}]);return DoNotDisturbScheduleItemDirective}(BaseControllerBackedDirective);let


DoNotDisturbScheduleItemController=function(){
function DoNotDisturbScheduleItemController(dateService){_classCallCheck(this,DoNotDisturbScheduleItemController);
this._startTimeOfDayLabel=this.getScheduleTime(this.schedule.startTimeOfDay);
this._endTimeOfDayLabel=this.getScheduleTime(this.schedule.endTimeOfDay);
this._scheduleTimezone=Formatters.formatInLocale(dateService.now(),'',this.schedule.timeZone,{displayTimeZone:!0});
this._isAllDaySchedule=this.schedule.startTimeOfDay===0&&this.schedule.endTimeOfDay===0;
}DoNotDisturbScheduleItemController.prototype.

onTogglePauseClicked=function onTogglePauseClicked(){
return this.togglePauseCommand.execute(this.schedule);
};DoNotDisturbScheduleItemController.prototype.

onDeleteClicked=function onDeleteClicked(){
return this.deleteCommand.execute(this.schedule);
};DoNotDisturbScheduleItemController.prototype.

getScheduleTime=function getScheduleTime(millisecondsSinceMidnight){
return moment(LocalMidnight+millisecondsSinceMidnight).format('h:mm A');
};_createClass(DoNotDisturbScheduleItemController,[{key:'startTimeOfDayLabel',get:function()

{
return this._startTimeOfDayLabel;
}},{key:'endTimeOfDayLabel',get:function()

{
return this._endTimeOfDayLabel;
}},{key:'scheduleTimezone',get:function()

{
return this._scheduleTimezone;
}},{key:'isAllDaySchedule',get:function()

{
return this._isAllDaySchedule;
}}]);return DoNotDisturbScheduleItemController}();


module.exports=DoNotDisturbScheduleItemDirective;
module.exports.controller=DoNotDisturbScheduleItemController;
//# sourceMappingURL=doNotDisturbScheduleItemDirective.js.map
